import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { useAuth } from "../../contexts/AuthContext";
import React, { useEffect, useState } from "react";
import { useDatabase } from "../../contexts/DatabaseContext";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  IconButton,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import Skelet from "../Skelet";
import { db } from "../../firebase";
import { useHistory, useLocation } from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Purchases() {
  const { currentUser } = useAuth();
  const history = useHistory();
  const { cancelPurchase, setReceived, removeReceived } = useDatabase();
  let query = useQuery();
  const [uid, setUid] = useState(currentUser.uid);
  const [purchased, setPurchased] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (query.get("id") !== null) {
      setUid(query.get("id"));
    } else {
      setUid(currentUser.uid);
    }
  }, [uid]);

  useEffect(() => {
    db.collection("users")
      .doc(currentUser.uid)
      .onSnapshot((doc) => {
        if (doc.exists) {
          setUser(doc.data());
        }
      });

    db.collection("purchases")
      .where("userId", "==", uid)
      .onSnapshot(async (junctions) => {
        const purchasedId = junctions.docs.map((doc) => doc.data().prizeId);
        const temp = [];
        const prizes = (await db.collection("prizes").get());
        purchasedId.forEach((id, i) => {
          prizes.forEach((prize) => {
            if (prize.id === id) {
              let purchase = {
                id: prize.id,
                name: prize.data().name,
                price: prize.data().price,
                image: prize.data().image,
                received: junctions.docs[i].data().received,
              };

              temp.push(purchase);
            }
          });
        });

        setPurchased(temp);
      });
  }, [uid]);

  let data = <Skelet />;

  let renderPurchases = (docs, isAdmin) => {
    return docs.map((doc, i) => {
      return (
          <Grid key={i} item md={3} xs={12}>
            <Card sx={{ height: "100%" }}>
              <CardMedia component="img" height="375px" image={doc.image} />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {doc.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Цена: {doc.price}
                </Typography>
                {doc.received ? (
                    <Chip
                        sx={{ mt: 1 }}
                        size="small"
                        label="Получено"
                        color="success"
                        variant="outlined"
                    />
                ) : (
                    <Chip
                        sx={{ mt: 1 }}
                        size="small"
                        label="Не получено"
                        color="error"
                        variant="outlined"
                    />
                )}
              </CardContent>
              <CardActions>
                {!isAdmin ? null : doc.received ? (
                    <Button
                        onClick={() => {
                          handleRemoveReceived(doc.id);
                        }}
                        size="small"
                    >
                      Отменить
                    </Button>
                ) : (
                    <Button
                        onClick={() => {
                          handleSetReceived(doc.id);
                        }}
                        size="small"
                    >
                      Подтвердить
                    </Button>
                )}

                {isAdmin ? null : doc.received ? null : (
                    <Button
                        onClick={() => {
                          handleDelete(doc.id);
                        }}
                        size="small"
                    >
                      Убрать
                    </Button>
                )}
              </CardActions>
            </Card>
          </Grid>
      );
    });
  };

  let handleDelete = (id) => {
    cancelPurchase(uid, id);
  };

  let handleSetReceived = (id) => {
    setReceived(uid, id);
  };

  let handleRemoveReceived = (id) => {
    removeReceived(uid, id);
  };



  try {

    if (purchased !== null){
      data = renderPurchases(purchased, user.isAdmin);
    }

  } catch (e) {

  }

  return (
    <>
      <Container
        component="main"
        sx={{ marginTop: 2, marginBottom: 2 }}
        maxWidth="xl"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card>
              <CardActions>
                <IconButton
                  onClick={() => {
                    history.push("/");
                  }}
                >
                  <ArrowBackIcon />
                </IconButton>
              </CardActions>
              <CardContent>
                <Typography
                  fontFamily="Mossport"
                  sx={{ fontSize: 25 }}
                  color="text.secondary"
                >
                  ПРИЗЫ
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {data}
        </Grid>
      </Container>
    </>
  );
}

export default Purchases;
